import React from 'react'
import ByteplusLiveStream from 'features/byte-plus';

const EmbedComponent = ({apiKey, contentId}) => {
    if (contentId==="embed-live-stream" && apiKey) {
        return <ByteplusLiveStream apiKey={apiKey} />;
    }
    return null;   
}

export default EmbedComponent;